import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box, Stack, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'

import { EXPORT_QUESTION_BANK, EXERCISES_REVIEW } from '@/config'
import { useGlobalContext } from '@/context/GlobalContext'
import { getAgentFeatures } from '@/store/common/actions'
import { getCommonState } from '@/store/common/selector'
import ChildPageHeader from '@/components/UI/ChildPageHeader'
import { PureCarousel } from '@/components/UI/PureCarousel'
import { ExploreButton } from '@/components/UI/ExploreButton'
import QuizzesGridView from '../Quizzes/QuizzesGridView'
import exportImg from '@/assets/New-images/export.svg'
import knowledgeImg from '@/assets/New-images/quick-start-knowledge.svg'
import genQueAnsImg from '@/assets/New-images/gen-que-ans-img.svg'
import complaint from '@/assets/New-images/complaint.svg'
import { useHeader } from '@/hooks/useHeader'

const ExercisesGrid = (props: any) => {
  const { isArchive } = props
  const { t } = useTranslation('translation')
  const dispatch = useDispatch()
  const history = useHistory()
  const { setExportQuestions } = useGlobalContext()
  const { setHeaderText } = useHeader()
  const commonState = useSelector(getCommonState)
  const [createQuizModal, setCreateQuizModal] = useState<
    'quiz' | 'roleplay' | undefined | null
  >(null)
  const [isRolePlayEnabled, setRolePlayEnabled] = useState(false)

  useEffect(() => {
    setHeaderText('Activities')
  }, [setHeaderText])

  useEffect(() => {
    // const query = new URLSearchParams(location.search)
    // const tab = query.get('tab')

    const getAgentFeature = async () => {
      const agentFeatures: any = await dispatch(getAgentFeatures())
      const rolePlayFeature = agentFeatures.find(
        (feature: any) => feature.name === 'quiz_roleplay',
      )

      setRolePlayEnabled(rolePlayFeature && rolePlayFeature.status === 'active')
    }
    getAgentFeature()
  }, [])

  return (
    <section className="page-mid-wraper h-without-foter">
      {isArchive && <ChildPageHeader title={t('Archived Activities')} />}
      {!isArchive && (
        <Box
          sx={{
            position: 'sticky',
            zIndex: 10,
            background: 'white',
            pb: '16px',
          }}
        >
          <PureCarousel>
            <ExploreButton
              icon={knowledgeImg}
              title={t('Build Quiz')}
              onClick={() => setCreateQuizModal('quiz')}
              fullWidth
            />
            {isRolePlayEnabled && (
              <ExploreButton
                icon={genQueAnsImg}
                title={t('Create Role Play')}
                onClick={() => setCreateQuizModal('roleplay')}
                fullWidth
              />
            )}
            <ExploreButton
              icon={complaint}
              title={t('Review Submissions')}
              route={EXERCISES_REVIEW}
              fullWidth
            />
            <ExploreButton
              icon={exportImg}
              title={t('Export Questions')}
              onClick={() => {
                setExportQuestions({
                  rows: null,
                  selectedYear: commonState.selectedYear._id,
                })
                history.push(EXPORT_QUESTION_BANK)
              }}
              fullWidth
            />
          </PureCarousel>
        </Box>
      )}
      <QuizzesGridView
        isArchive={isArchive}
        createQuizModal={createQuizModal}
        setCreateQuizModal={setCreateQuizModal}
      />
    </section>
  )
}

export default ExercisesGrid
